<template>
    <div>
        <div class="banner">
            <h4>{{ title }}</h4>
        </div>

        <v-form @submit.prevent="create" ref="form">
            <v-row dense>
                <v-col cols="12" sm="12" class="d-flex flex-column align-center justify-center">
                    <h4 class="mb-2 text-center">
                        Para qual tipo de paciente é este motivo?
                        <span style="color: red;">*</span>
                    </h4>

                    <v-radio-group v-model="resource.kind_of_donor_id" row class="d-flex justify-center">
                        <v-radio label="ME"  :value="1"></v-radio>
                        <v-radio label="PCR" :value="2"></v-radio> 
                    </v-radio-group>
                </v-col>
                <v-col class="d-flex" cols="12" sm="12">
                    <v-text-field class="rounded-lg" color="#41916b" outlined maxlength="100" counter="100"
                        v-model="resource.description" :rules="formRules" dense>
                        <template v-slot:label>
                            Descrição do Motivo <span style="color: red;">*</span>
                        </template>
                    </v-text-field>
                </v-col> 
                <v-col cols="12" sm="12" class="d-flex flex-column align-center justify-center">
                    <h4 class="mb-2 text-center">
                        Esse motivo possui submotivos?
                        <span style="color: red;">*</span>
                    </h4>

                    <v-radio-group v-model="hasSubReasons" row class="d-flex justify-center">
                        <v-radio label="Sim" :value="true"></v-radio>
                        <v-radio label="Não" :value="false"></v-radio>
                    </v-radio-group>
                </v-col>
                <template v-if="hasSubReasons"> 
                <v-col class="d-flex align-center" cols="12" sm="12" v-for="(sub, index) in subReasons" :key="index">
                    <v-text-field class="rounded-lg" color="#41916b" outlined maxlength="200" counter="200"
                        v-model="sub.description" :rules="formRules" dense>
                        <template v-slot:label>
                            Descrição do Submotivo {{ index + 1 }} <span style="color: red;">*</span>
                        </template>

                        <template v-slot:append>
                            <v-tooltip top color="red" v-if="index > 0">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="red" class="mr-2" style="cursor: pointer;" v-bind="attrs" v-on="on"
                                        @click="removeSubReason(index)">
                                        mdi-delete
                                    </v-icon>
                                </template>
                                <span style="color: white">Remover submotivo</span>
                            </v-tooltip>
                        </template>
                    </v-text-field>

                    <v-tooltip top color="#41916b" v-if="index == subReasons.length - 1">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mb-7 ml-1" small fab dark color="#41916b" v-bind="attrs" v-on="on"
                                @click="addReason()">
                                <v-icon dark>mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <span style="color:white">Inserir mais</span>
                    </v-tooltip>
                </v-col>
            </template>
            </v-row>
            <v-card-actions class="d-flex justify-end">
                <v-btn class="rounded-lg" color="#e74c3c" text elevation="0" @click="closeDialog()">
                    <span>{{$t('buttons.cancel')}}</span>
                </v-btn>

                <v-btn class="rounded-lg" color="blue" text elevation="0" @click="$refs.form.reset()">
                    <span>{{$t('buttons.clean_up')}}</span>
                </v-btn>

                <v-btn class="rounded-lg" elevation="0" color="#41916b" type="submit" :loading="loading">
                    <span class="textBtn">{{ btnMessage }}</span>
                    <v-icon color="#FFFFFF" small class="ml-2">mdi-arrow-right</v-icon>
                </v-btn>
            </v-card-actions>
        </v-form>
    </div>
</template>
<script>
import { saveReasonNotValidation } from "@/service/basic-registrations/ReasonNotValidationService";
import Formatters from "@/utils/Formatters";
import { mapActions } from "vuex";

export default {
    data() {
        return {
            dialog: false,
            formRules: [(v) => !!v || "Campo obrigatório."],
            loading: false,
            hasSubReasons: false,
            subReasons: [
                { description: '' }
            ],
        };
    },

    props: {
        resource: {
            type: Object,
        }
    },

    computed: {
        title() {
            return this.resource.id ? 'Atualizar Motivo de Não Validação' : 'Novo Motivo de Não Validação';
        },

        btnMessage() {
            return this.resource.id ? 'Atualizar' : 'Salvar';
        }
    },

    watch: {
        resource: {
            handler(item) {
                this.normalizeResource(item);

                if (!item.id && this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
            },

            immediate: true
        }
    },

    methods: {
        ...mapActions([
            "changeSnackBarData"
        ]),

        addReason() {
            this.subReasons.push({ description: '' });
        },

        removeSubReason(index) {
            if (index === 0) return;
            this.subReasons.splice(index, 1);
        },

        normalizeResource(item) {  
            const list = item.reason_assessments || []; 
 
            this.hasSubReasons = this.resource.id ? list.length > 0 : null

            this.subReasons = this.hasSubReasons
            ? list.map(reasons => ({ description: reasons.description }))
            : [{ description: '' }];

            this.resource.type_reason_not_captured_id =
            item.type_reason_not_captured_id
                ? parseInt(item.type_reason_not_captured_id)
                : null;
            this.resource.kind_of_donor_id = parseInt(item.kind_of_donor_id);
        },

        create() {
            this.loading = true;
            if (this.$refs.form.validate()) { 
                const subReasons = this.subReasons

                const dados = {
                    description: this.resource.description,
                    kind_of_donor_id: this.resource.kind_of_donor_id,
                    reason_assessments: subReasons
                }

                saveReasonNotValidation(this.resource.id || null, dados).then((response) => {
                    this.loading = false;

                    this.changeSnackBarData({
                        status: true,
                        type: 'success',
                        titleMessage: response.data.message,
                        bodyMessage: '',
                        cardColor: 'success',
                        titleIcon: 'mdi-check-circle',
                    });

                    setTimeout(() => {
                        this.closeSnackBar();
                        this.closeDialog();
                    }, 3000);

                }).catch((err) => {
                    this.loading = false;
                    this.changeSnackBarData({
                        status: true,
                        type: 'erro',
                        titleMessage: this.$t('messages.something_went_wrong'),
                        bodyMessage: Formatters.formatErrorMessage(err),
                        cardColor: 'red',
                        titleIcon: 'mdi-close-circle',
                    });

                    setTimeout(() => {
                        this.closeSnackBar();
                    }, 3000);
                });
            }
        },

        closeDialog() {
            this.$refs.form.reset();
            this.$refs.form.resetValidation();

            this.subReasons = [{ description: '' }];
            this.hasSubReasons = null;

            this.$emit("closeDialog");
        },

        closeSnackBar() {
            this.changeSnackBarData({
                status: false,
                type: '',
                titleMessage: '',
                bodyMessage: '',
                cardColor: '',
                titleIcon: '',
            });
        }
    },
};
</script>
<style scoped>
.textBtn {
    font-family: "Poppins";
    color: #ffffff;
}

.card {
    padding: 35px;
}

.banner {
    background: #b3ffab;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right,
            #41916b,
            #1abc9c);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right,
            #41916b,
            #b8e0cd);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

    border-radius: 8px;

    margin-bottom: 20px;

    display: flex;
    align-items: center;
}

.banner>h4 {
    color: #ffffff;
    padding: 10px;
}
</style>